<template>
  <div v-if="isLoggedIn">
    <h4>YOU CANNOT ACCESS THIS PAGE WHILE LOGGED IN. PLEASE LOG OUT AND RE-OPEN THE LINK TO ACCESS.</h4>
  </div>
  <div v-else class="content">
    <div class="reset-wrapper">
      <div class="reset">
        <PublicBrandHeader />
        <h3>Nurse Verification</h3>
        <form id="subaccountform" @submit.prevent="handleVerifyNurse">
          <div v-if="allFormErrors.length" class="form-error-summary" role="alert">
            <ul>
              <li v-for="(err, idx) in allFormErrors" :key="idx">{{ err }}</li>
            </ul>
          </div>
          <div class="mb-2">
            <div class="row mb-2 gx-2">
              <div class="col-md-6 col-12 form-group form-floating mb-2 mb-lg-0">
                <select
                  id="accnttype"
                  class="form-control"
                  v-model="accountTypeChild"
                  required
                  disabled
                >
                  <option value="">Select account type</option>
                  <option value="Administrator">Administrator</option>
                  <option value="Licensed Practical Nurse">
                    Licensed Practical Nurse
                  </option>
                  <option value="Registered Nurse">Registered Nurse</option>
                  <option value="Provider">Provider</option>
                </select>
                <label for="AccntRole" class="profile_label"> Account Type:</label>
              </div>
              <div class="col-md-6 col-12 form-group form-floating mb-2 mb-lg-0">
                <input
                  type="text"
                  name="accountexternid"
                  id="Accntexternid"
                  class="form-control"
                  disabled
                  v-model="form.externid"
                />
                <label for="AccntId" class="profile_label">ID #:</label>
              </div>
            </div>
            <div class="row mb-2 gx-2">
              <div class="col-md-4 col-12 form-group form-floating mb-2 mb-lg-0">
                <input
                  type="text"
                  name="firstname"
                  id="AccntFname"
                  required
                  class="form-control"
                  placeholder="Required"
                  v-model="form.first"
                />
                <label for="AccntFname" class="profile_label"><span style="color:#ff0000;font-weight:600;">*</span>First Name:</label>
              </div>
              <div class="col-md-4 col-12 form-group form-floating mb-2 mb-lg-0">
                <input
                  type="text"
                  name="lastname"
                  id="AccntLname"
                  class="form-control"
                  placeholder="Required"
                  required
                  v-model="form.last"
                />
                <label for="AccntLname" class="profile_label"><span style="color:#ff0000;font-weight:600;">*</span>Last Name:</label>
              </div>
              <div class="col-md-4 col-12 form-group form-floating mb-2 mb-lg-0">
                <input
                  type="text"
                  name="accountUname"
                  id="AccntpUsername"
                  class="form-control"
                  placeholder="Required"
                  required
                  v-model="form.login"
                  @keyup="validateUsername"
                />
                <label for="AccntUsername" class="profile_label"><span style="color:#ff0000;font-weight:600;">*</span>Username:</label>
              </div>
            </div>
            <div class="row mb-2 gx-2">
              <div class="col-md-6 col-12 form-group form-floating mb-2 mb-lg-0">
                <input
                ref="pwd"
                  :type="showPassword ? 'text' : 'password'"
                  name="accountPw"
                  id="AccntPw"
                  required
                  placeholder="Enter password"
                  class="form-control"
                  v-model="form.password"
                  @change="validatePassword"
                />
                <button
                  type="button"
                  class="pwd-toggle"
                  @click="togglePassword"
                  @mousedown.prevent
                  :aria-pressed="showPassword"
                  :title="showPassword ? 'Hide password' : 'Show password'"
                  style="background:none; border:none; margin-left:-36px; cursor:pointer;margin-left: 281px;margin-top: 0px;position: absolute;top: 15px;cursor: pointer;"
                  >
                  <!-- simple eye / eye-off SVG (swap based on show) -->
                  <svg v-if="!showPassword" width="20" height="20" viewBox="0 0 24 24" fill="none" aria-hidden>
                    <path d="M1 12s4-7 11-7 11 7 11 7-4 7-11 7S1 12 1 12z" stroke="currentColor" stroke-width="1.5"/>
                    <circle cx="12" cy="12" r="3" stroke="currentColor" stroke-width="1.5"/>
                  </svg>
                  <svg v-else width="20" height="20" viewBox="0 0 24 24" fill="none" aria-hidden>
                    <path d="M3 3l18 18" stroke="currentColor" stroke-width="1.5"/>
                    <path d="M1 12s4-7 11-7c2 0 3 .5 4 1.3" stroke="currentColor" stroke-width="1.5"/>
                  </svg>
                  </button>
                <label for="AccntPw" class="profile_label"><span style="color:#ff0000;font-weight:600;">*</span>Password:</label>
              </div>
              <div class="col-md-6 col-12 form-group form-floating mb-2 mb-lg-0">
                <input
                ref="pwd2"
                   :type="showPassword ? 'text' : 'password'"
                  name="accountPwConfirm"
                  id="AccntPwConfirm"
                  required
                  placeholder="Confirm password"
                  class="form-control"
                  v-model="form.password2"
                  @change="confirmPassword"
                />
                <button
                  type="button"
                  class="pwd-toggle"
                  @click="togglePassword"
                  @mousedown.prevent
                  :aria-pressed="showPassword"
                  :title="showPassword ? 'Hide password' : 'Show password'"
                  style="background:none; border:none; margin-left:-36px; cursor:pointer;margin-left:275px;margin-top: 0px;position: absolute;top: 15px;cursor: pointer;"
                  >
                  <!-- simple eye / eye-off SVG (swap based on show) -->
                  <svg v-if="!showPassword" width="20" height="20" viewBox="0 0 24 24" fill="none" aria-hidden>
                    <path d="M1 12s4-7 11-7 11 7 11 7-4 7-11 7S1 12 1 12z" stroke="currentColor" stroke-width="1.5"/>
                    <circle cx="12" cy="12" r="3" stroke="currentColor" stroke-width="1.5"/>
                  </svg>
                  <svg v-else width="20" height="20" viewBox="0 0 24 24" fill="none" aria-hidden>
                    <path d="M3 3l18 18" stroke="currentColor" stroke-width="1.5"/>
                    <path d="M1 12s4-7 11-7c2 0 3 .5 4 1.3" stroke="currentColor" stroke-width="1.5"/>
                  </svg>
                  </button>
                <label for="AccntPwConfirm" class="profile_label"
                  ><span style="color:#ff0000;font-weight:600;">*</span>Confirm Password:</label
                >
              </div>
            </div>
            <div class="row mb-2 gx-2">
              <div class="col-md-5 col-12 form-group form-floating mb-2 mb-lg-0">
                <input
                  type="email"
                  name="accountEmail"
                  id="AccntEmail"
                  required
                  placeholder="Required"
                  class="form-control"
                  v-model="form.email"
                  disabled
                />
                <label for="AccntEmail" class="profile_label"><span style="color:#ff0000;font-weight:600;">*</span>Account Email:</label>
              </div>
              <!-- <div class="col-md-2 col-12 form-group form-floating mb-2 mb-lg-0">
                <select
                  v-model="form.primaryPhoneType"
                  class="col-12 form-select"
                  required
                >
                  <option v-for="phone in phoneTypes" :key="phone.id" :value="phone.id">
                    {{ phone.type }}
                  </option>
                </select>
                <label class="profile_label">Phone type</label>
              </div> -->
              <div class="col-md-4 col-12 form-group form-floating mb-2 mb-lg-0">
                <input
                  type="text"
                  id="regphone"
                  class="form-control"
                  v-model="form.cell"
                  placeholder="Required"
                />
                <label for="mblphone" class="profile_label"><span style="color:#ff0000;font-weight:600;">*</span>Phone Number</label>
              </div>
              <div class="col-md-3 col-12 form-group form-floating mb-2 mb-lg-0">
                <select id="commpref" class="form-select" v-model="form.pref">
                  <option value="Email" selected>Email</option>
                  <option value="SMS">SMS</option>
                  <option value="Phone">Phone</option>
                  <option value="All">All</option>
                </select>
                <label for="AccntPref" class="profile_label">Communication Preference:</label>
              </div>
            </div>
            <div class="row mb-2 gx-2">
              <div class="col-md-5 col-12 form-group form-floating mb-2 mb-lg-0">
                <input
                  type="text"
                  name="personalAddress"
                  id="AccntAddress"
                  class="form-control"
                  placeholder="Required"
                  v-model="form.addr"
                />
                <label for="AccntAddress" class="profile_label"><span style="color:#ff0000;font-weight:600;">*</span>Address:</label>
              </div>
              <div class="col-md-3 col-12 form-group form-floating mb-2 mb-lg-0">
                <input
                  v-model="form.city"
                  type="text"
                  name="personalcity"
                  id="AccntCity"
                  class="form-control"
                  placeholder="Required"
                />
                <label for="AccntCity" class="profile_label"><span style="color:#ff0000;font-weight:600;">*</span>City:</label>
              </div>
              <div class="col-md-2 col-12 form-group form-floating mb-2 mb-lg-0">
                <select
                  v-model="form.state"
                  name="personalstate"
                  id="AccntState"
                  class="form-select"
                >
                  <option value="">Select a state</option>
                  <option
                    v-for="(state, index) in states"
                    :key="index"
                    :value="state.abbr"
                  >
                    {{ state.abbr }}
                  </option>
                </select>
                <label for="AccntState" class="profile_label"><span style="color:#ff0000;font-weight:600;">*</span>State:</label>
              </div>
              <div class="col-md-2 col-12 form-group form-floating mb-2 mb-lg-0">
                <input
                  v-model="form.zip"
                  type="text"
                  name="personalzip"
                  id="AccntZip"
                  class="form-control"
                  placeholder="Required"
                />
                <label for="AccntZip" class="profile_label"><span style="color:#ff0000;font-weight:600;">*</span>Zip:</label>
              </div>
            </div>
            <!-- <div class="col-sm-12 col-md-12 col-lg-12 npi-container"> -->
            <!-- <div class="col-sm-12 col-md-12 col-lg-12 npi-license">
                <label for="Npiproflicense">NPI:</label>
                <input
                  v-model="form.npi"
                  type="text"
                  name="Npipersonalicense"
                  id="AccntNpilicense"
                />
              </div> -->
            <!--- <div class="col-sm-12 col-md-6 col-lg-6">
                        <label for="NpiAccntdob">Date of Birth:</label><br>
                        <input type="date" name="Npiaccntdob" id="NpiAccntdobd" placeholder="Date of Birth"/>
                    </div>-->
            <!--<div class="col-sm-12 col-md-6 col-lg-6">
                        <label for="NpiAccntSS">last 4 Social Number:</label><br>
                        <input type="text" name="NpiaccountSS" id="NpiAccntSS" placeholder="Last 4 Social Security #"/>
                    </div>-->
            <!-- </div> -->
            <!-- <div class="col-sm-12 col-md-6 col-lg-6">
                        <label for="AccntSS">last 4 Social Number:</label><br>
                        <input type="text" name="accountSS" id="AccntSS" placeholder="Last 4 Social Security #"/>
                    </div>-->
            <div class="row mb-2 gx-2">
              <div
                class="col-md-6 col-12 form-group form-floating mb-2 mb-log-0"
              >
                <!-- <span v-if="fileprocessing" class="formprocess">....processing</span> -->
                <input
                  class="form-control"
                  type="file"
                  name="licenseFile"
                  id="licensePdf"
                  @change="uploadLicense(form,$event)"
                />
                <label for="files" class="profile_label">
                <span v-if="!hasLicense" style="color:#ff0000;font-weight:600;">*</span>
                <span v-else="hasLicense" class="file-indicator file-indicator--ok" aria-hidden="true" title="File attached">✓</span>
                Upload License PDF:</label>
              </div>
              <div
                class="col-md-6 col-12 form-group form-floating mb-2 mb-log-0"
              >
                <input
                  class="form-control"
                  type="file"
                  name="insuranceFile"
                  id="insurancePdf"
                  @change="uploadInsurance(form,$event)"
                />
                <label for="files" class="profile_label">
                <span v-if="!hasInsurance" style="color:#ff0000;font-weight:600;">*</span>
                <span v-else="hasInsurance" class="file-indicator file-indicator--ok" aria-hidden="true" title="File attached">✓</span>
                Upload Insurance PDF:</label>
              </div>
            </div>
            <div class="row mb-2 gx-2">
              <!-- <div class="col-md-2 col-12 form-group form-floating mb-2 mb-lg-0">
                <select
                  v-model="form.gender"
                  name="accountGender"
                  id="AccntGender"
                  required
                  class="form-select"
                >
                  <option value="">Please select</option>
                  <option value="1">Male</option>
                  <option value="2">Female</option>
                </select>
                <label for="AccntGender" class="profile_label">Gender:</label>
              </div> -->
              <!-- <div class="col-md-4 col-12 form-group form-floating mb-2 mb-lg-0">
                <select id="AccntPref" class="form-select" v-model="form.pref">
                  <option value="Email" selected="selected">Email</option>
                  <option value="SMS">SMS</option>
                  <option value="Phone">Phone</option>
                  <option value="All">SMS, Phone & Email</option>
                </select>
                <label for="AccntPref" class="profile_label"
                  >Communication Preference:</label
                >
              </div> -->
              <div class="col-md-4 col-12 form-group form-floating mb-2 mb-lg-0">
                <input
                  class="form-control"
                  type="text"
                  name="personalicense"
                  id="Accntproflicense"
                  v-model="form.license"
                />
                <label for="Accntproflicense" class="profile_label"
                  ><span style="color:#ff0000;font-weight:600;">*</span>Professional License:</label
                >
              </div>
              <div class="col-md-2 col-12 form-group form-floating mb-2 mb-lg-0">
                <select
                  v-model="form.licenseSt"
                  name="licensestate"
                  id="LicenseState"
                  class="form-select"
                >
                  <option value="">Select a state</option>
                  <option
                    v-for="(state, index) in states"
                    :key="index"
                    :value="state.abbr"
                  >
                    {{ state.abbr }}
                  </option>
                </select>
                <label for="AccntState" class="profile_label"><span style="color:#ff0000;font-weight:600;">*</span>License State:</label>
              </div>
              <div class="col-md-2 col-12 form-group form-floating mb-2 mb-lg-0">
                <input
                  id="dob"
                  v-model="form.dob"
                  class="form-control"
                  required
                  type="date"
                />
                <label for="dob" class="profile_label">DOB:</label>
              </div>
              <div class="col-md-2 col-12 form-group form-floating mb-2 mb-lg-0">
                <input
                  id="ssn"
                  v-model="form.ssn"
                  class="form-control col-md-6"
                  type="text"
                />
                <label for="SSN" class="profile_label"><span style="color:#ff0000;font-weight:600;">*</span>SSN (last four):</label>
              </div>
            </div>
            <div class="row mb-2 gx-2">
              <div class="col-md-4 col-12 form-group form-floating mb-2 mb-lg-0">
                <input
                  type="text"
                  name="insuranceCompany"
                  id="insuranceCompany"
                  class="form-control"
                  required
                  v-model="form.insuranceCompany"
                />
                <label for="insuranceCompany" class="profile_label"
                  ><span style="color:#ff0000;font-weight:600;">*</span>Insurance Company:</label
                >
              </div>
              <div class="col-md-2 col-12 form-group form-floating mb-2 mb-lg-0">
                <input
                  required
                  class="form-control"
                  v-model="form.insuranceStart"
                  type="date"
                  id="insuranceStart"
                  name="insuranceStart"
                />
                <label for="insuranceStart" class="profile_label"><span style="color:#ff0000;font-weight:600;">*</span>Insurance Start:</label>
              </div>
              <div class="col-md-2 col-12 form-group form-floating mb-2 mb-lg-0">
                <input
                  required
                  class="form-control"
                  v-model="form.insuranceEnd"
                  type="date"
                  id="insuranceEnd"
                  name="insuranceEnd"
                />
                <label for="insuranceEnd" class="profile_label"><span style="color:#ff0000;font-weight:600;">*</span>Insurance End:</label>
              </div>
              <div class="col-md-2 col-12 form-group form-floating mb-2 mb-lg-0">
                <input
                  required
                  class="form-control"
                  v-model="form.perIncidentAmnt"
                  type="number"
                  id="perIncidentAmnt"
                  name="perIncidentAmnt"
                />
                <label for="perIncidentAmnt" class="profile_label"
                  >Per Incident Limit:</label
                >
              </div>
              <div class="col-md-2 col-12 form-group form-floating mb-2 mb-lg-0">
                <input
                  required
                  class="form-control"
                  v-model="form.annualAggAmnt"
                  type="number"
                  id="annualAggAmnt"
                  name="annualAggAmnt"
                />
                <label for="annualAggAmnt" class="profile_label">Annual Limit:</label>
              </div>
            </div>
            <div class="row mb-2 gx-2">
              <div class="accountform-btn">
                <input
                  type="submit"
                  class="btn btn-primary"
                  value="Submit & Verify"
                  id="sbmtuserbtn"
                />
                <button class="return__link btn btn-primary">
                  <router-link to="/login" class="form__link"
                    >Return to log in</router-link
                  >
                </button>
              </div>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>
<script>
import { mask } from "vue-the-mask";
import { CURR_API, OTHER_API } from "@/constants/apis";
import { finalizeRegistration, updatePassword, updateUsername, isUserExist } from "@/api/userApi";
import axios from "axios";
import { refusalMessage } from "@/api/refusals";
import { isFileUid } from "@/utils/fileUrl";
import { inviteHeaders } from "@/utils/inviteHeader";
import { forgetInviteToken, inviteTokenOnArrival, queryWithoutInvite } from "@/utils/inviteToken";
import { missingVerifyNurseFields } from "@/utils/verifyNurseValidation";
import { inviteRefusal, runVerifyNurseFlow } from "@/utils/verifyNurseFlow";
import { notPendingMessage } from "@/utils/pendingAccountStatus";
import us from "us";
import router from "@/router/index";
import { LoginNavigation } from "@/store/modules/fsm/messages";
import VALIDATION_ERRORS from "@/data/validationErrors";
import { getPasswordPolicyErrors } from "@/utils/passwordPolicy";
import { h,ref } from "vue";
import PublicBrandHeader from '@/components/public-layouts/PublicBrandHeader.vue';
const password = ref('')
const show = ref(false)
const pwd = ref(null)
const pwd2 = ref(null)
const file = ref(null)
export default {
  name: "verify-nurse-page",
  components: {
    PublicBrandHeader,
  },
  directives: {
    mask,
  },
  data() {
    return {
      accountTypeChild: this.accountType,
      // Whether keyon holds a stored license / insurance file for this nurse
      // (GetPendingAccountInfo has_*_file, or a re-upload that returned a uid).
      hasLicense: false,
      hasInsurance: false,
      states: us.states,
      // Provisional username from pending account_user; skip self in uniqueness check.
      originalLogin: "",
      form: {
        externid: "",
        first: "",
        last: "",
        login: "",
        password: "",
        password2: "",
        enrollmentId: null,
        dob: null,
        email: "",
        addr: "",
        city: "",
        state: "",
        zip: null,
        cell: null,
        ssn: "",
        license: "",
        licenseSt: "",
        pref: "Email",
        insuranceCompany: "",
        insuranceStart: "",
        insuranceEnd: "",
        perIncidentAmnt: 0,
        annualAggAmnt: 0,
       
      },
      nurseType: null,
      formErrors: {},
      validationAr:[],
      isValidated:true,
      requiredFields:['First Name','Last Name','Address','City','State','Zip','Proof of License','license Number','License State','DOB','Social']
    };
  },
  props: {
    accountType: {
      type: String,
      default: ""
    },
    unique: {
      type: String,
      default: ""
    },
    accntnum: {
      type: String,
      default: ""
    },
    // The invite e-mail's single-use token (router query `invite`).
    invite: {
      type: String,
      default: ""
    },
  },
  computed: {
    isLoggedIn: function () {
      let isLoggedIn = store.getters["login/isLoggedIn"];
      return isLoggedIn;
    },
    /** Flattens formErrors + validationAr into one top-of-form summary. */
    allFormErrors() {
      const out = [];
      for (const key in this.formErrors) {
        const fieldErrors = this.formErrors[key];
        if (Array.isArray(fieldErrors)) {
          for (const msg of fieldErrors) {
            if (msg) out.push(msg);
          }
        }
      }
      if (Array.isArray(this.validationAr)) {
        for (const msg of this.validationAr) {
          if (msg) out.push(msg);
        }
      }
      return out;
    },
  },
  beforeCreate() {
    if (this.isLoggedIn) {
      alert("Please logout to verify account");
      router.push({ name: LoginNavigation });
    }
    let isInit = this.$gotInitialMessage();
    if (!isInit) {
      let href = location.href + "";
      setTimeout(() => location.assign(href), 5000);
    }
  },
  created() {
    // Kept as a plain instance field, not in data(), so it is not reactive and
    // not in devtools state. It came in the hash fragment, which never reaches a
    // server or a Referer, and it is never logged. The strip below takes it out
    // of the address bar, so it is also kept in this tab's sessionStorage,
    // keyed by the pending account: a reload used to lose it, every later
    // lookup then went out without the invite header, and keyon's gate refused
    // them all (utils/inviteToken.js). forgetInvite() drops both copies once the
    // finalize has used it or keyon says it is spent.
    this.inviteToken = inviteTokenOnArrival(this.unique, this.invite);
    if (this.$route && this.$route.query && "invite" in this.$route.query) {
      router.replace({ path: this.$route.path, query: queryWithoutInvite(this.$route.query) }).catch(() => {});
    }
    for (let key in this.form) {
      // this.$set(this.formErrors, key, []);
      this.formErrors[key] = []
    }
  },
  async mounted() {
    this.webHook({
      Account: {
        API_Meth: "GetPendingAccountInfo",
        accountype: this.accountTypeChild,
        uniqueNine: this.unique,
      },
    }).then((res) => {
      console.log("Verfify Nurse Account being Returned");
      console.log(res.data);
      if (res?.data?.status == "No Records Found") {
        router.push({ name: LoginNavigation });
        alert("There is an error with this verification link. Please request a new one.");
        return;
      } else {
        let dbData = res.data.data[0];
        if (dbData.account_status != "Pending") {
          router.push({ name: LoginNavigation });
          // Expired has its own sentence (utils/pendingAccountStatus.js).
          alert(notPendingMessage(dbData.account_status));
          return;
        }
        this.form.externid = dbData.unique_ID;
        this.form.login = dbData.username;
        this.originalLogin = dbData.username || ""; // baseline for change detection
        this.form.first = dbData.user_Fname;
        this.form.last = dbData.user_Lname;
        this.form.email = dbData.user_email;
        this.form.addr = dbData.address;
        this.form.city = dbData.city;
        this.form.state = dbData.state;
        this.form.zip = dbData.zip;
        this.form.cell = dbData.user_phone;
        this.form.license = dbData.proffesionalLicense;
        this.form.licenseSt = dbData.licenseState || "";
        this.form.pref = dbData.communication_preference || "Email";
        this.form.insuranceCompany = dbData.insuranceCompany || "";
        this.form.insuranceStart = this.formatDateInput(dbData.insuranceStart);
        this.form.insuranceEnd = this.formatDateInput(dbData.insuranceEnd);
        this.form.perIncidentAmnt = dbData.perIncLimit != null && dbData.perIncLimit !== ""
          ? dbData.perIncLimit
          : 0;
        this.form.annualAggAmnt = dbData.annLimit != null && dbData.annLimit !== ""
          ? dbData.annLimit
          : 0;
        this.nurseType = dbData.account_type;
        this.hasInsurance = !!dbData.has_insurance_file;
        this.hasLicense = !!dbData.has_license_file;
        
      }
    });
  },
  methods: {
    formatDateInput(value) {
      if (!value) {
        return "";
      }
      const raw = String(value).trim();
      if (/^\d{4}-\d{2}-\d{2}/.test(raw)) {
        return raw.slice(0, 10);
      }
      return raw;
    },
    validate() {
      for (let key in this.formErrors) {
        if (this.formErrors[key] && this.formErrors[key].length > 0) {
          return false;
        }
      }
      return true;
    },
    // Live username checks (format + uniqueness via existing isUserExist).
    async validateUsername() {
      const usernameRegex = /^([a-zA-Z]|_)+([a-zA-Z0-9_])*$/;
      this.form.login = (this.form.login || "").trim();
      this.formErrors.login = [];
      if (!usernameRegex.test(this.form.login)) {
        this.formErrors.login.push(VALIDATION_ERRORS.USERNAME_CHARACTERS);
      }
      if (this.form.login.length < 8 || this.form.login.length > 24) {
        this.formErrors.login.push(VALIDATION_ERRORS.USERNAME_LENGTH);
      }
      // Skip lookup when invitee keeps the provisional username from Add User.
      if (this.formErrors.login.length < 1 && this.form.login !== this.originalLogin) {
        try {
          const userExists = await isUserExist(this.form.login);
          // Assign (don't push) so overlapping isUserExist replies can't stack the same message.
          this.formErrors.login = userExists ? [VALIDATION_ERRORS.USERNAME_EXISTS] : [];
        } catch (err) {
          this.formErrors.login = [String(err?.message || err || "Unable to check username.")];
        }
      }
    },
    // Write new login to Postgres then MySQL before finalize / InternalAddNurse.
    async persistUsernameIfChanged() {
      const next = (this.form.login || "").trim();
      if (!next || next === this.originalLogin) {
        return; // no rename needed
      }
      // Postgres LA_user.ZV_user_login (login authority).
      await updateUsername({
        externid: this.form.externid,
        username: next,
      });
      // MySQL account_user (+ nurses.username when that row already exists).
      const mysqlRes = await this.webHook({
        Account: {
          API_Meth: "UpdatePendingAccountUsername",
          accountnumber: this.accntnum || this.form.accountnumber,
          uniqueNine: this.unique || this.form.externid,
          username: next,
        },
      });
      if (mysqlRes?.data?.status !== "200" && mysqlRes?.data?.message !== "Updated") {
        throw new Error(mysqlRes?.data?.message || "Unable to update username in organization records.");
      }
      this.originalLogin = next; // treat as current for any later checks
    },
    togglePassword(event) {
    
    this.showPassword = !this.showPassword;
    // keep focus on the main password input
    this.$nextTick(() => {
      const el = this.$refs.pwd;
      if (el && el.focus) el.focus();
      const ell = this.$refs.pwd2;
      if (ell && ell.focus) ell.focus();
    });
  },
    validatePassword() {
      this.formErrors.password = getPasswordPolicyErrors(this.form.password, [
        this.form.first,
        this.form.middle,
        this.form.last,
      ]);

      if (this.form.password2 && this.form.password2 !== "") {
        this.confirmPassword();
      }
    },
    confirmPassword() {
      this.formErrors.password2 = [];
      if (this.form.password !== this.form.password2) {
        this.formErrors.password2.push(VALIDATION_ERRORS.PASSWORD_MISMATCH);
      }
    },
    confimMustHave()
    {
      this.validationAr = missingVerifyNurseFields(this.form, {
        hasLicenseFile: this.hasLicense,
        hasInsuranceFile: this.hasInsurance,
      });
      return this.validationAr.length === 0;
    },
    async handleVerifyNurse() {
      //Gonna try and vlidate the array before running the validate 
      if(this.confimMustHave())
    {
      this.isValidated = true;
    }
    else{
    
      console.log("ValidationAr Info");
      console.log(this.validationAr);
      this.isValidated =false;
      return;
    }
      if (!this.validate()) {
        this.$swal({
          type: "warning",
          title: "Error",
          text: "Please fix the errors in the form to finish registering this account.",
        });
        return;
      }
      let loader = null;
      loader = this.$loading.show(
        {
          container: this.$refs.pageBody,
        },
        {
          after: () => h("div", {}, 
            `Verifying license and updating profile...`,
          ),
        }
      );
      // Lookup, enrolment only on a genuine "not on the list", lookup again,
      // then the finalize: utils/verifyNurseFlow.js, which closes the loader
      // and says something on every path, a refused request included.
      await runVerifyNurseFlow(
        {
          form: this.form,
          ltype: this.nurseType == "Licensed Practical Nurse" ? "LPN" : "RN",
        },
        {
          lookup: (request) => this.startLookup(request),
          add: (request) => this.startAdd(request),
          complete: (licence, closer) => this.completeNurseVerification(closer, licence),
          notify: (message) => this.$swal(message),
          hide: () => loader.hide(),
          inviteSpent: () => this.forgetInvite(),
        }
      );
    },
    // The invite is used up or dead: drop the in-memory copy and this tab's
    // stored one, so a later submit does not spend Nursys requests on it.
    forgetInvite() {
      this.inviteToken = null;
      forgetInviteToken(this.unique);
    },
    async completeNurseVerification(loader, licenseLookupRow) {
      try {
        await this.validateUsername(); // await so uniqueness errors block submit
        if (!this.validate()) {
          loader.hide();
          this.$swal({
            type: "warning",
            title: "Error",
            text: "Please fix the username errors before continuing.",
          });
          return;
        }
        await this.persistUsernameIfChanged(); // rename before finalize / nurse insert
        await finalizeRegistration(this.form.externid);
        await updatePassword({
          email: this.form.email,
          newPassword: this.form.password,
        });
        const licenseExp =
          licenseLookupRow?.LicenseExpirationDate != null
            ? String(licenseLookupRow.LicenseExpirationDate).substring(0, 10)
            : "";
        const internalAddResult = await this.startInternalAdd({
          accountnumber: this.accntnum,
          extern: this.form.externid,
          firstname: this.form.first,
          lastname: this.form.last,
          username: this.form.login,
          licensnum: this.form.license,
          ltype: this.nurseType == "Licensed Practical Nurse" ? "LPN" : "RN",
          email: this.form.email,
          primephone: this.form.cell,
          address1: this.form.addr,
          city: this.form.city,
          state: this.form.state,
          zip: this.form.zip,
          licenseExp,
          insuranceCompany: this.form.insuranceCompany,
          insuranceStart: this.form.insuranceStart,
          insuranceEnd: this.form.insuranceEnd,
          perIncidentAmnt: this.form.perIncidentAmnt,
          annualAggAmnt: this.form.annualAggAmnt,
        });
        if (internalAddResult?.data?.message != "Inserted") {
          console.log(internalAddResult);
          throw new Error(
            internalAddResult?.data?.message ||
              "Erriff Health Verification Platform - Account Not Verified Successfully. Please Sync All Account Data."
          );
        }
        // keyon consumed the invite in the transaction that inserted her, so
        // neither copy is any use now.
        this.forgetInvite();
        console.log("Account Verified in Mysql");
        const backEndAccountResult = await this.VerifyBackEndAccount();
        if (backEndAccountResult !== "Account Finalized") {
          throw new Error(
            "Erriff Health Verification Platform - Account Not Verified Successfully. Please Sync All Account Data."
          );
        }
        loader.hide();
        await this.$swal({
          type: "success",
          title: "Success!",
          text:
            "Your account has been verified successfully and activated. You will now be redirected to our login screen.",
        });
        router.push({ name: LoginNavigation });
      } catch (err) {
        loader.hide();
        // A 403 invite_required (spent or expired invite) gets the same invite
        // wording as the lookup, and the dead token is dropped.
        const invite = inviteRefusal(err);
        if (invite && invite.inviteSpent) {
          this.forgetInvite();
        }
        this.$swal({
          type: "error",
          title: "Error",
          text: (invite && invite.text) || refusalMessage(err?.response?.data) || err?.message || String(err) || "Unable to verify account. Please try again.",
        });
        // Status or message only: an axios error carries config.headers, and the
        // finalize request's headers hold the invite token.
        console.error("Finalize failed:", err?.response?.status || err?.message);
      }
    },
    async VerifyBackEndAccount() {
      return this.webHook({
        Account: {
          API_Meth: "UpdatePendingAccountInfo",
          Accountstatus: "Active",
          uniqueNine: this.unique,
          accountnumber: this.accntnum || this.form.accountnumber,
        },
      }).then((res) => {
        console.log("RETURNED VERIFIED ACCOUNT RESULT");
        console.log(res.data);
        if (res.data.message === "Updated" && !res.data.error) {
          return "Account Finalized";
        }
        if (res.data.error && res.data.error != "") {
          console.log("Logging Finalization Error");
          console.log(res.data.error);
          return "Account Not Finalized";
        }
      }).catch((err) => {
        console.error("Finalization failed:", err?.response?.status || err?.message);
        return "Account Not Finalized";
      });
    },
    async webHook(request, headers = {}) {
      return await axios.post(CURR_API + "/tswebhook.php", request, {
        headers: { "Content-Type": "application/json;", ...headers },
      });
    },
    // Finalizing without a session is authorized by the invite token, sent as
    // a header so it stays out of keyon's request-body log.
    async startInternalAdd(request) {
      return this.webHook({
        ManageNurseList: {
          API_Meth: "InternalAddNurse",
          hospitalpracsetting: "",
          notficationenabled: "N",
          reminderenabled: "N",
          locationlist: "",
          activestatus: "YES",
          secondaryphone: "",
          bdayear: this.form.dob || "1970-01-01",
          lastfourssn: this.form.ssn || "", //making this dynamic versus empty by default (KW - Nurse Table)
          address2: "",
          action:"Verify Nurse Account", //This property is what I'll use to reuse the same function and update account_user table at the same time
          ...request,
        },
      }, inviteHeaders(this.inviteToken));
    },
    // License/insurance re-upload on verify, authorized by the invite token.
    async uploadLicense(form, $e)
    {
      const nwform = new FormData();
      const files = $e.target.files;
      nwform.append("API_Meth", "UploadNurseLicenseFile");
      nwform.append("accountnumber", this.accntnum);
      nwform.append("externId", form.externid);
      nwform.append("nurseLicenseFile", files[0]);
      // No Content-Type: the browser writes the multipart boundary.
      axios.post(CURR_API + '/tswebhook.php', nwform, { headers: inviteHeaders(this.inviteToken) })
        .then(response => {
          // keyon answers with the stored file's uid; the page only needs to
          // know a license is now on file.
          if (response.data.message == "Updated" && isFileUid(response.data.file_uid)) {
            this.hasLicense = true;
            alert("PDF Updated Successfully");
          } else if (refusalMessage(response.data)) {
            alert(refusalMessage(response.data));
          }
        })
        .catch(error => {
          // 403 invite_required for a missing or spent invite, 413 for an
          // oversized file, 503 when uploads are unavailable: in keyon's words.
          const refusal = refusalMessage(error?.response?.data);
          if (refusal) alert(refusal);
          else console.error('Upload failed:', error?.response?.status || error?.message);
        });
    },
    //uploadInsurance  File
    async uploadInsurance(form, $e)
    {
      const nwform = new FormData();
      const files = $e.target.files;
      nwform.append("API_Meth", "UploadNurseInsuranceFile");
      nwform.append("accountnumber", this.accntnum);
      nwform.append("externId", form.externid);
      nwform.append("nurseInsuranceFile", files[0]);
      // No Content-Type: the browser writes the multipart boundary.
      axios.post(CURR_API + '/tswebhook.php', nwform, { headers: inviteHeaders(this.inviteToken) })
        .then(response => {
          // keyon answers with the stored file's uid; the page only needs to
          // know a insurance document is now on file.
          if (response.data.message == "Updated" && isFileUid(response.data.file_uid)) {
            this.hasInsurance = true;
            alert("PDF Updated Successfully");
          } else if (refusalMessage(response.data)) {
            alert(refusalMessage(response.data));
          }
        })
        .catch(error => {
          // 403 invite_required for a missing or spent invite, 413 for an
          // oversized file, 503 when uploads are unavailable: in keyon's words.
          const refusal = refusalMessage(error?.response?.data);
          if (refusal) alert(refusal);
          else console.error('Upload failed:', error?.response?.status || error?.message);
        });
    },
    async startLookup(request) {
      // The invite is what authorizes this page: it is unauthenticated by
      // design, and keyon's gate picks the public arm from the presence of
      // this header, not from a missing account number. Sent as a header so
      // it stays out of keyon's request-body log, as the finalize already does.
      return this.webHook(
        {
          NursyInfo: {
            API_Meth: "LookupNursesInfo",
            accountnumber: this.accntnum,
            extern: this.form.externid,
            ...request,
          },
        },
        inviteHeaders(this.inviteToken)
      );
    },
    async startAdd(request) {
      return this.webHook(
        {
          ManageNurseList: {
            API_Meth: "Add_Nurse",
            ncsid: "",
            subactioncode: "A",
            accountnumber: this.accntnum,
            extern: this.form.externid,
            address2: "",
            hostpracsettingother: "",
            locationlist: "",
            recid: "",
            ...request,
          },
        },
        inviteHeaders(this.inviteToken)
      );
    },
  },
};
</script>

<style scoped lang="scss">
@import "../../stylesheets/mixins/alignment";
$color-base: #0060ff;
.btn--login {
  color: #fff;
  background-color: $color-base;

  &:hover {
    background-color: lighten($color-base, 5%);
  }
}
.return__link {
  float: right;
  background-color: $color-base;
}
.form__link {
  color: white;
  text-decoration: none;
}
#sbmtuserbtn {
  border-radius: 0.375em;
}
.button-group {
  /*margin-top: 1.5rem;*/

  .form__link {
    color: $color-base;
    font-size: 0.85rem;
    margin-top: 0.5rem;
    display: block;

    &:hover {
      text-decoration: underline;
    }
  }
}
.content {
  width: 100%;
  height: auto;
  background: url("../../assets/images/bg.jpg") no-repeat center fixed; // TODO image subject to copyright
  background-size: cover;
  position: relative;
}
.reset-wrapper {
  height: 100vh;
  width: 100%;
  position: relative;
}

.reset {
  width: 60% !important;
  background-color: #fff;
  padding: 2rem;
  -moz-box-shadow: 0 2px 2px 0 rgba(0, 0, 0, 0.14), 0 3px 1px -2px rgba(0, 0, 0, 0.12),
    0 1px 5px 0 rgba(0, 0, 0, 0.2);
  box-shadow: 0 2px 2px 0 rgba(0, 0, 0, 0.14), 0 3px 1px -2px rgba(0, 0, 0, 0.12),
    0 1px 5px 0 rgba(0, 0, 0, 0.2);

  @include absoluteCenter(380px);

  > h3 {
    text-align: center;
  }
}
.reset__introduction {
  color: darken(gray, 10%);
  font-size: 14px;
  text-align: center;
}
.btn--reset {
  color: #fff;
  background-color: $color-base;
  &:hover {
    background-color: lighten($color-base, 5%);
  }
}

.button-group {
  margin-top: 1.5rem;

  .form__link {
    color: $color-base;
    font-size: 0.85rem;
    margin-top: 0.5rem;
    display: block;

    &:hover {
      text-decoration: underline;
    }
  }
}

.form__input {
  font-size: 0.85rem;
}
.col-form-label {
  font-size: 14px;
  width: 100%;
}

@media only screen and (max-width: 768px) {
  .reset {
    width: 90% !important;
    height: 90%;
    overflow: auto;
  }
}

.file_link {
  font-weight: bold;
}

.form-error-summary {
  margin: 0.75rem 0 1.5rem;
  padding: 0.9rem 1.15rem;
  background: #fdecea;
  border: 1px solid #f3b4b0;
  border-radius: 6px;
}

.form-error-summary ul {
  margin: 0;
  padding-left: 1.1rem;
  color: #9b2c2c;
}

.form-error-summary li {
  margin: 0.15rem 0;
}
</style>
